import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import SEO from "../components/SEO";

export default function Destinations() {
    const [cities, setCities] = useState([]);

    useEffect(() => {
        api.get("/cities").then((r) => setCities(r.data)).catch(() => {});
    }, []);

    return (
        <>
            <SEO
            title="Destinations — 16 communes Normandie & Picardie"
            description="16 communes du territoire Côte Perdue : Le Tréport, Mers-les-Bains, Cayeux-sur-Mer, Eu, Bois-de-Cise, Ault, Blangy-sur-Bresle, Aumale, Neufchâtel-en-Bray, Foucarmont, Berneval-le-Grand, Criel-sur-Mer, Mesnil-Val, Saint-Martin-le-Gaillard, Envermeu, Gamaches."
            path="/destinations"
        />
            <div className="pt-28" data-testid="destinations-page">
            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pt-16 md:pt-24 pb-16">
                <p className="cp-tiny text-cp-foret mb-8">Chapitre I · Destinations · {cities.length || 16} lieux du territoire</p>
                <h1 className="cp-serif text-4xl sm:text-5xl md:text-[56px] lg:text-[72px] xl:text-[92px] leading-[1.02] text-cp-encre max-w-5xl tracking-[-0.025em]">
                    De <em className="cp-display-italic text-cp-foret">Petit-Caux</em><br />
                    à <em className="cp-display-italic text-cp-foret">Cayeux</em>.
                </h1>
                <p className="cp-serif italic text-xl md:text-2xl font-light text-cp-gris leading-relaxed mt-12 max-w-3xl">
                    Côte et vallée de la Bresle — de la crique d'Oscar Wilde à Berneval aux bambouseraies du Jardin Jungle, du Château d'Eu à la distillerie de calvados d'Aumale, en passant par le Musée du Verre de Blangy. Une cartographie sélective, rien de touristique.
                </p>
            </section>

            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pb-32">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
                    {cities.map((city, idx) => (
                        <Link
                            to={`/destinations/${city.slug}`}
                            key={city.id}
                            data-testid={`destinations-card-${city.slug}`}
                            className={`group block cp-card-hover ${
                                idx % 2 === 0 ? "md:col-span-7" : "md:col-span-5 md:mt-24"
                            }`}
                        >
                            <div className={`cp-image-zoom overflow-hidden bg-cp-craie mb-6 ${
                                idx % 2 === 0 ? "aspect-[16/10]" : "aspect-[4/5]"
                            }`}>
                                <img src={city.hero_image} alt={city.name} loading="lazy" className="w-full h-full object-cover" />
                            </div>
                            <p className="cp-kicker text-[10px] text-cp-bleu-gris mb-2">0{city.position || idx + 1}</p>
                            <h2 className="cp-serif text-4xl md:text-5xl leading-tight text-cp-noir mb-3 group-hover:text-cp-foret transition-colors">
                                {city.name}
                            </h2>
                            <p className="text-cp-gris italic text-lg font-light mb-4">{city.tagline}</p>
                            <p className="text-cp-gris text-base font-light leading-relaxed line-clamp-3 max-w-2xl">
                                {city.description}
                            </p>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    </>

    );
}
